import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { AppDispatch } from "../app/store";
import { closeModal, toggleModal } from "../features/modalSlice";
import useOutsideClick from "../hooks/useOutsideClick"; // Import the hook
import { apiService } from "../services/apiService";

const ModalCreateFolder: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const modalRef = useRef<HTMLDivElement | null>(null);
  const [Loading, setLoading] = useState<boolean>(false);

  // State to control the animation
  const [isVisible, setIsVisible] = useState<boolean>(false);

  // State for input value (folder name)
  const [inputValue, setInputValue] = useState<string>("");

  // Trigger animation on modal open
  useEffect(() => {
    setIsVisible(true);
  }, []);

  // Close the modal on outside click
  useOutsideClick({
    modalRef,
    closeAction: () => dispatch(closeModal("ModalCreateFolder")),
  });

  // Handle save button click
  const handleSave = async () => {
    if (inputValue.trim()) {
      try {
        setLoading(true);
        // Call the createFolder API method
        await apiService.createFolder(inputValue.trim(), "chat");
        dispatch(toggleModal());
        // Close the modal after folder is created
        dispatch(closeModal("ModalCreateFolder"));
        setLoading(false);
        toast.success("Folder Created", {
          className:
            "md:!bg-[#00B21B]/20 !bg-[#00B21B]/100 dark:!text-white dark:text-[#191919] !shadow-none",
          duration: 2000,
        });
      } catch (error) {
        // Handle error
        toast.error("Error", {
          className:
            "md:!bg-[#FD7272]/20 !bg-[#FD7272]/100 dark:!text-white dark:text-[#191919] !shadow-none",
          duration: 2000,
        });
        setLoading(false);
      }
    } else {
      // setError("Folder name cannot be empty.");
    }
  };
  return (
    <div className="relative ">
      <div className="fixed md:backdrop-blur-[auto] backdrop-blur-10 inset-0 flex  justify-center items-center z-50">
        <div
          className={`md:bg-none md:bg-transparent dark:bg-chatDarkBg/70 bg-lightBg/70 md:mx-auto mx-2 border-[#5F829F]/50 md:border-0 border-[0.2px]  ${
            isVisible ? "scale-100 opacity-100 translate-y-0" : "scale-95 opacity-0 translate-y-4"
          } custom-modal-bg rounded-3xl max-w-[37.5rem] w-full h-[132px] relative backdrop-blur-[42px]`}
          ref={modalRef}
        >
          {/* Modal Content */}
          <h2 className="text-base px-6 pt-4 pb-1 text-black dark:text-white font-ProximaLight">
            Create new folder
          </h2>
          <div className="flex px-6 py-3">
            <input
              type="text"
              required
              value={inputValue} // Bind state to input
              onChange={(e) => setInputValue(e.target.value)} // Update state on change
              className="bg-transparent rounded-x-lg rounded-l-lg border-[#5f829f73] border-[0.2px] focus:outline-none h-[43px] w-full px-6 py-3 dark:text-white"
              placeholder="Folder name"
            />
            <button
              onClick={handleSave}
              className="backdrop-blur-[42px] rounded-x-lg rounded-r-lg border-[#5f829f73] border-r-[0.2px] border-y-[0.2px] text-black dark:text-white text-sm font-ProximaLight h-[43px] w-[71px]"
            >
              {/* {Loading ? "Loading.." : "Save"} */}
              {Loading ? <span className="loader-dots block mx-auto"></span> : "Save"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalCreateFolder;
